import * as _ from 'lodash';

import { IFormSubmissionDto, AppState, ICamper, ParentSP, IEmergency, IWaivers, IHealth } from "../classes/index";
import { StepOneModel } from "../camp-sign-up/redux/reducers/step-one-reducer";
import { StepTwoModel } from '../camp-sign-up/redux/reducers/step-two-reducer';
import { StepFourModel } from '../camp-sign-up/redux/reducers/step-four-reducer';
import { StepThreeModel } from '../camp-sign-up/redux/reducers/step-three-reducer';

export function parseBoolean(input: string): boolean {
    if (!input || input.length === 0)
        return null;

    return input.toLowerCase() === "true" || input.toLowerCase() === "t";
}

function convertStepOneToCamper(state: StepOneModel): ICamper {
    // Set parent to send correspondence..
    const correspondenceIdx = parseInt(state.parentInformation.sendCorrespondenceTo);

    const parentInformation: Array<ParentSP> = state.parentInformation.parents.map((parent, idx) => {
        const parentSP: ParentSP = {
            address: parent.address,
            city: parent.city,
            email: parent.email,
            firstName: parent.firstName,
            lastName: parent.lastName,
            state: parent.state,
            zip: parent.zip,
            homePhone: parent.homePhone.number,
            cellPhone: parent.cellPhone.number,
            workPhone: parent.workPhone.number,
            primaryPhone: "",
            correspondence: false
        };

        // Find the PRIMARY phone.
        if (parent.homePhone.isPrimary)
            parentSP.primaryPhone = "home";
        else if (parent.cellPhone.isPrimary)
            parentSP.primaryPhone = "cell";
        else if (parent.workPhone.isPrimary)
            parentSP.primaryPhone = "work";

        if (correspondenceIdx === 2 || correspondenceIdx === idx) {
            return _.assign({}, parentSP, { correspondence: true });
        }

        return _.assign({}, parentSP);
    });

    return {
        basicInformation: state.basicInformation,
        parentInformation: { parents: parentInformation },
        siblings: state.siblings,
        aboutMyChild: state.aboutMyChild
    }
}

function convertStepTwoToEmergency(state: StepTwoModel): IEmergency {
    return {
        contacts: state.emergencyContacts,
        healthCare: state.healthCareContacts,
        insurance: state.insuranceInformation,
        pickups: state.pickupAuthorization,
        permissions: state.transportationPermission
    }
}

function convertStepThreeToHealth(state: StepThreeModel): IHealth {
    const dietarySection = {
        dietaryRestrictions: state.dietarySection
    };

    let conditions = state.medicalConditionsSection.medicalConditions.map(condition => {
        if (condition.canSelfAdminister === null)
            condition.canSelfAdminister = false;

        if (condition.childHasMedication === null)
            condition.childHasMedication = false;

        if (condition.keptWithChild === null)
            condition.keptWithChild = false;

        return condition;
    });

    state.medicalConditionsSection.medicalConditions = conditions;

    return {
        administeringMedication: state.administeringMedication,
        allergySection: state.allergySection,
        dietarySection: dietarySection,
        immunizations: state.immunizations,
        medicalConditionsSection: state.medicalConditionsSection,
        medicationsSection: state.medicationSection,
        specialNeedsSection: state.specialNeedsSection
    };
}

function convertStepFourToWaivers(state: StepFourModel): IWaivers {
    return {
        mediaRelease: state.mediaRelease,
        emergencyRoomRelease: state.emergencyRoomRelease,
        fieldTripPermission: state.fieldTripPermission,
        liability: state.liability,
        wellChild: state.wellChild
    }
}

export function convertReducersToDto(state: AppState): IFormSubmissionDto {
    let submission: IFormSubmissionDto = {
        camper: convertStepOneToCamper(state.stepOneModel),
        emergency: convertStepTwoToEmergency(state.stepTwoModel),
        health: convertStepThreeToHealth(state.stepThreeModel),
        waivers: convertStepFourToWaivers(state.stepFourModel)
    };



    return submission;
}


// WEBPACK FOOTER //
// ./app/helpers/parser.ts